import React from 'react'

let year = new Date().getFullYear()

const Footer = () => {
    return (<>
        <div className="overlay toggle-btn-mobile" />
        {/*end overlay*/}
        {/* eslint-disable-next-line no-script-url */}
        {/*Start Back To Top Button*/} {/* <a href="javaScript:" className="back-to-top"><i className="bx bxs-up-arrow-alt" /></a> */}
        {/*End Back To Top Button*/}
        {/*footer */}
        <div className="footer">
            <p className="footer-timezone mb-0"><span aria-hidden="true">ⓘ</span> All times are shown in your local timezone.</p>
            <p className="footer-copyright mb-0">Copyright &copy; {year} The Haylo. All Right Reserved</p>
        </div>
    </>)
}

export default Footer;
